import { toBlob } from "html-to-image";

/**
 * Captures the current screen (document.body) as a PNG File for attaching
 * to a support ticket. Returns null if capture fails — callers should treat
 * that as "no screenshot available" rather than blocking the report flow.
 */
export const captureScreenshot = async (): Promise<File | null> => {
  try {
    const blob = await toBlob(document.body, {
      cacheBust: true,
      pixelRatio: 1,
      backgroundColor:
        getComputedStyle(document.body).backgroundColor || "#ffffff",
      filter: (node) =>
        !(node instanceof HTMLElement) ||
        node.getAttribute("data-screenshot-ignore") !== "true",
    });
    if (!blob) return null;
    return new File([blob], `screenshot-${Date.now()}.png`, {
      type: "image/png",
    });
  } catch {
    return null;
  }
};

export default captureScreenshot;
